import API from '../../apis';
import {
  action,
  generateErrorAction
} from '../actions';
import actionTypes from './actionTypes';

export const fetchAllRoles = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.roles
        .fetchAllRoles(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(generateErrorAction(err, {
            failure: actionTypes.FETCH_ROLES_FAILED,
            reject: actionTypes.FETCH_ROLES_REJECT
          }));
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_ROLES_LOADING);
  const success = res => action(actionTypes.FETCH_ROLES_SUCCESS, res);

  return request();
};